<!--  -->
<template>
  <div>

    <el-row>
        <el-col :span="24">
            评分项 :{{ruleForm.name}}
        </el-col>
    </el-row>

    <el-card class="box-card" style="margin-top:15px;">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
            <el-row>
              <el-col :span="16">
                  <el-form-item label="评价期" prop="name">
                      {{ruleForm.currentAppraisePeriod}}
                  </el-form-item>
              </el-col>
              <el-col :span="8">
                  <el-form-item label="历史" prop="name">
                      {{ruleForm.lastAppraisePeriod}}
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                  <el-form-item label="供应商自评Score" prop="currentSupplierScore">
                      {{ruleForm.currentSupplierScore}}
                  </el-form-item>
              </el-col>
              <el-col :span="10">
                  <el-form-item label="Final Score" prop="currentFinalScore">
                    <el-input v-model="ruleForm.currentFinalScore" :disabled="(status=='CQS已提交'||status=='已发布')&&statusView=='O'||statusView=='OC'&&(status=='CQS已提交'||status=='已发布')?false:true"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="8">
                  <el-form-item label="历史Score" prop="lastSupplierScore">
                    {{ruleForm.lastSupplierScore}}
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                  <el-form-item label="供应商自评Facts" prop="name">
                    <el-tooltip class="item" effect="dark" :content="ruleForm.currentSupplierFacts" placement="top-start">
                      <span style="display: inline-block;width: 120px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{ruleForm.currentSupplierFacts}}</span>
                    </el-tooltip>
                  </el-form-item>
              </el-col>
              <el-col :span="10">
                  <el-form-item label="Final Facts" prop="currentFinalFacts" >
                    <div style="display:flex;">
                        <el-input type="textarea" style="width:82%" @input="getLength" maxlength="1000" :autosize="{ minRows: 4, maxRows: 4}"  :rows="4" v-model="ruleForm.currentFinalFacts" :disabled="(status=='CQS已提交'||status=='已发布')&&statusView=='O'||statusView=='OC'&&(status=='CQS已提交'||status=='已发布')?false:true"></el-input>
                        <div style="display: flex;justify-content: center;align-items: center;font-size: 12px;color: #909399;">{{enter}}/1000</div>
                    </div>
                  </el-form-item>
              </el-col>
              <el-col :span="8">
                  <el-form-item label="历史Facts" prop="lastSupplierFacts">
                    <el-tooltip class="item" effect="dark" :content="ruleForm.lastSupplierFacts" placement="top-start">
                      <span style="display: inline-block;width: 120px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{ruleForm.lastSupplierFacts}}</span>
                    </el-tooltip>
                    
                  </el-form-item>
              </el-col>
            </el-row>
      </el-form>
    </el-card>
    <el-row type="flex" class="row-bg" justify="center">
        <el-button v-if="(status=='CQS已提交'||status=='已发布')&&statusView=='O'||statusView=='OC'&&(status=='CQS已提交'||status=='已发布')" type="primary" @click="submitForm('ruleForm')">保存</el-button>
    </el-row>

  </div>
</template>

<script>
import ratingTask from "@/api/AAA/ratingTask.js";
import scoreSummary from "@/api/AAA/scoreSummary.js";

export default {
  props:['detailInfo','dialoagId'],
  data () {
    return {
        enter:"",
        identity:localStorage.getItem('ms_emplFlag'),
        status:JSON.parse(sessionStorage.getItem("taskDetail")).status,
        rulesList:localStorage.getItem('ms_roles'),
        statusView:"",
        ruleForm: {},
        rules: {
          resource: [
            { required: true, message: '请选择活动资源', trigger: 'change' }
          ],
          desc: [
            { required: true, message: '请填写活动形式', trigger: 'blur' }
          ]
        }
    };
  },
  created(){
    let permission = JSON.parse(localStorage.getItem("ms_Permission"));
    if(this.detailInfo.currentFinalFacts&&this.detailInfo.currentFinalFacts.length>0){
      this.enter=this.detailInfo.currentFinalFacts.length
    }
    this.ruleForm=this.detailInfo
    if (this.identity=='SUP') {   //判断是供应商
      this.statusView = 'S';
    }else {
      if(this.rulesList.indexOf('QSPI_AAA_CQS')!=-1&&this.rulesList.indexOf('QSPI_AAA_OWNER')!=-1){
        this.statusView = 'OC';
      }else{
        for (let i = 0, len = permission.length; i < len; i++) {
          if (permission[i] == 'QSPI_AAA_OWNER') {
            this.statusView = 'O';
            break
          }else{
            this.statusView = 'C';
          }
        }
      }
      // for (let i = 0, len = permission.length; i < len; i++) {
      //   if (permission[i] == 'QSPI_AAA_OWNER') {
      //     this.statusView = 'O';
      //     return
      //   }else{
      //     this.statusView = 'C';
      //   }
      // }
    }
  },
  components: {},

  computed: {},

  methods: {
    getLength(){
      this.enter=this.ruleForm.currentFinalFacts.length
    },
    submitForm(name){
        if(this.ruleForm.currentFinalScore>this.ruleForm.maxValue){
          this.$message.error('输入的数值不能超过最大分数,请重新输入')
          return 
        }
       let arr=[{
         facts:this.ruleForm.currentFinalFacts,
         score:Number(this.ruleForm.currentFinalScore),
         wtScore:Math.floor(100*this.ruleForm.currentFinalScore*this.ruleForm.wt1*10) / 100,
         ttQspiAaaScoreDetailId: this.dialoagId
       }]
       let params={
         scoreBody:arr,
         isFromSummary:true
       }
      ratingTask.saveFinalScore(params,this.ruleForm.ttQspiAaaScoreId).then((res)=>{
        if(res.code==200){
          this.$message.success("保存成功")
          this.$emit('closeDialog')
        }else{
          this.$message.error(res.msg)
        }
      })
    },
  },
  watch:{
    detailInfo(val){
      this.ruleForm=val
    }
  }
}

</script>
<style  scoped>

</style>